module.exports = __webpack_public_path__ + "img/workerhead.7308ca18.jpg";